const SUPPORTED_ROOM_CODES = new Set(['offensivesecurityintro']);

export const isTaskBreakdownRoom = (roomCode: string) => SUPPORTED_ROOM_CODES.has(roomCode);
